export default "__VITE_ASSET__kRbZ5vT4__"